import { render, staticRenderFns } from "./EmpirePanel.vue?vue&type=template&id=ce709d92&"
import script from "./EmpirePanel.vue?vue&type=script&lang=js&"
export * from "./EmpirePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports